import * as React from 'react'
import type { SVGProps } from 'react'
const SvgTelegram = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_10037_1881)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 10.6152C20 16.1381 15.5228 20.6152 10 20.6152C4.47715 20.6152 0 16.1381 0 10.6152C0 5.09239 4.47715 0.615234 10 0.615234C15.5228 0.615234 20 5.09239 20 10.6152ZM10.3584 7.99767C9.38571 8.40223 7.44178 9.23956 4.52658 10.5097C4.05319 10.6979 3.80521 10.8821 3.78264 11.0622C3.74449 11.3665 4.12559 11.4863 4.64456 11.6495C4.71515 11.6717 4.78829 11.6947 4.86328 11.7191C5.37386 11.885 6.06069 12.0792 6.41774 12.0869C6.74162 12.0939 7.10311 11.9604 7.5022 11.6863C10.226 9.84773 11.632 8.91841 11.7203 8.89837C11.7825 8.88424 11.8688 8.86647 11.9273 8.91844C11.9858 8.97041 11.98 9.06883 11.9738 9.09524C11.9361 9.25618 10.4401 10.647 9.66593 11.3667C9.42459 11.5911 9.25339 11.7502 9.2184 11.7866C9.14 11.868 9.06011 11.945 8.98332 12.0191C8.50897 12.4763 8.15326 12.8193 9.00301 13.3792C9.41137 13.6483 9.73814 13.8709 10.0641 14.0929C10.4201 14.3353 10.7752 14.5771 11.2347 14.8783C11.3517 14.955 11.4635 15.0347 11.5724 15.1123C11.9867 15.4077 12.359 15.6731 12.8188 15.6308C13.086 15.6062 13.3621 15.3549 13.5022 14.6055C13.8335 12.8345 14.4847 8.99728 14.6352 7.41605C14.6484 7.27751 14.6318 7.10021 14.6185 7.02238C14.6051 6.94455 14.5773 6.83366 14.4761 6.75157C14.3563 6.65435 14.1714 6.63385 14.0886 6.6353C13.7125 6.64193 13.1355 6.84258 10.3584 7.99767Z"
        fill="#4F5277"
      />
    </g>
    <defs>
      <clipPath id="clip0_10037_1881">
        <rect
          width={20}
          height={20}
          fill="white"
          transform="translate(0 0.615234)"
        />
      </clipPath>
    </defs>
  </svg>
)
export default SvgTelegram
